import { Stack, TextField } from '@mui/material';
import { useTranslate } from 'react-admin';
import type { AdminTenantListFilters, TenantStatus } from '@/api/models';
import { EnumMultiSelect } from '@/features/operations/filters/EnumMultiSelect';

const STATUS_VALUES: TenantStatus[] = ['active', 'suspended'];

interface TenantsFiltersFormProps {
  filters: AdminTenantListFilters;
  onChange: (patch: Partial<AdminTenantListFilters>) => void;
}

/** Every query parameter `GET /v1/admin/tenants` accepts, and no more: `q`, `status`. */
export function TenantsFiltersForm({ filters, onChange }: TenantsFiltersFormProps) {
  const translate = useTranslate();

  return (
    <Stack spacing={2.5}>
      <TextField
        size="small"
        label={translate('pay.tenants.filters.search')}
        helperText={translate('pay.tenants.filters.searchHelp')}
        value={filters.q ?? ''}
        onChange={(event) => onChange({ q: event.target.value || undefined })}
        fullWidth
      />
      <EnumMultiSelect
        label={translate('pay.tenants.filters.status')}
        options={STATUS_VALUES.map((value) => ({ value, label: translate(`pay.tenants.status.${value}`) }))}
        values={filters.status ?? []}
        onChange={(values) => onChange({ status: values.length > 0 ? (values as TenantStatus[]) : undefined })}
      />
    </Stack>
  );
}
